import { useEffect, Suspense } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import CookieConsent from './components/feature/CookieConsent';
import NewsletterPopup from './components/feature/NewsletterPopup';
import { trackPageView } from './utils/analytics';

function AppContent() {
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center bg-[#F8EDEA]">
            <div className="text-center">
              <i className="ri-loader-4-line text-4xl text-[#B97A72] animate-spin"></i>
              <p className="mt-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>Chargement...</p>
            </div>
          </div>
        }>
          <AppRoutes />
        </Suspense>
      </main>
      <Footer />
      <CookieConsent />
      <NewsletterPopup />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
